/**
 * Created by dongruihe on 2017/3/13.
 */
let util = require('../util.js');
import { url, useragent, sessionStore } from '@xhtech/lux'
// import interceptor from '../interceptors';
// interceptor();

import { encrypter, decrypter } from "../jwe";
Vue.use(require('vue-resource'));
let ajax = module.exports;
let base = GLOBAL_URL.ROOT;
const { getSearchParam } = url

console.log('base1:', base)
const isPrd = env.env === 'uat' || env.env === 'production'
// const isPrd = true

//base = 'http://10.3.208.85:8080'
// 获取 access_token
function getAccessToken() {
  let phone = getSearchParam('phone')
  let accessToken = util.getHashParam('access_token')
  let accessTokenStore = sessionStore.get('access_token') || {}

  if (!accessToken) {
    if (accessTokenStore.key === phone) {
      accessToken = accessTokenStore.value
    } else {
      accessToken = ''
    }
  } else {
    /**
     * 当 accessToken 可以从 hash 中获取时，表示已经联合登录完毕，
     * 此时可以从缓存中获取联合登录前的手机号，用于下一步更新缓存
     */
    phone = accessTokenStore.key
  }

  /**
   * 缓存配对的手机号和accessToken，联合登录前先缓存手机号，accessToken 为空，
   * 联合登录后，更新accessToken
   */
  accessTokenStore = {
    key: phone,
    value: accessToken
  }
  sessionStore.set('access_token', accessTokenStore)

  return accessToken
}

function ajaxFail(vm, response, error) {
  // 关闭loading
  if (response.status === 403) {
    let href = window.location.href
    let loginTem = ''
    let url = ''
    if (href.indexOf('share/lead.html') >= 0 || href.indexOf('lottery') >= 0) {
      //loginTem = 'share';
      //url ="/h5/login?view="+loginTem+"&redirect=";
      vm.isLogin = false;
      util.closeLoading();
      return;
    } else {
      loginTem = 'changecard';
      let isH5ProApi = response.url.indexOf('/h5pro-api/') > -1
      let isCouponApi = response.url.indexOf('/h5api/couponapi') > -1
      let isMarketApi = response.url.indexOf('/h5api/marketapi') > -1
      const loginUrl = encodeURIComponent(window.location.origin + '/xhpay/login')
      const redirect = encodeURIComponent(window.location.href)
      const appChannel = util.getParam('appChannel') || 'h5-xhcd'
      const scope = [
        'openid',
        'email',
        'address',
        'profile',
        'phone',
        'login_device',
        'cif_basic'
      ].join(' ')

      if (util.isAddGw()) {
        // token登录
        url = `/gw/auth/authorize?login_view_hint=borrow&redirect_uri=${redirect
          }&appChannel=${appChannel}&loginHtmlUrl=${loginUrl}&isGateway=true&response_type=token&client_id=xhH5loan&scope=${scope}`
      } else {
        // ios APP 走session登录
        if (util.isApp() && useragent.isIos()) {
          if (isH5ProApi) {
            url = `/h5pro-api/login?view=apply_p&redirect=${redirect}&appChannel=`
          } else if (isCouponApi || isMarketApi) {
            url = `/h5api/login?view=${loginTem}&redirect=${redirect}`
          } else {
            url = `/h5-loan/h5login?view=${loginTem}&redirect=${redirect}`
          }
        } else {
          // token登录
          url = `/auth/authorize?login_view_hint=borrow&redirect_uri=${redirect
            }&appChannel=${appChannel}&loginHtmlUrl=${loginUrl}&response_type=token&client_id=xhH5loan&scope=${scope}`
        }
      }
    }
    // url += encodeURIComponent(href);
    window.location.href = `${base}` + url;
    return;
  } else if (response.status === 404) {
    util.closeLoading();
    vm.failureState = {
      show: true
    };
  } else {
    util.closeLoading();
  }
  //响应错误响应
  if (typeof error == 'function' && error != null) {
    util.closeLoading();
    error(response);
    vm.failureState = {
      show: true
    };
  }
}

ajax.get = function (vm, url, params, success, error) {
  if (!params.hideLoading) {
    util.showLoading();
  }
  let newUrl = base + url
  if (util.isAddGw()) {
    newUrl = base + '/gw' + url
  }

  Vue.http.get(newUrl, params).then(function (response) {
    // 关闭loading
    util.closeLoading();
    //响应正确响应
    if (typeof success == 'function' && success != null) {
      try {
        success(JSON.parse(response.body));
      } catch (error) {
        console.error('请求响应格式错误：' + error + response)
      }
    }
  }, function (response) {
    ajaxFail(vm, response, error);
  });
};

ajax.post = function (vm, url, params, success, error) {
  if (!params.hideLoading) {
    util.showLoading();
  }
  let newUrl = base + url
  if (util.isAddGw()) {
    newUrl = base + '/gw' + url
  }

  Vue.http.post(newUrl, params).then(function (response) {
    // 关闭loading
    util.closeLoading();
    //响应正确响应
    if (typeof success == 'function' && success != null) {
      try {
        //   success(JSON.parse(response.body));
        if (response.data && typeof response.data == "string" && isPrd) {
          decrypter(response.data).then(function (decryptData) {
            if (decryptData.result) {
              response.data = JSON.parse(decryptData.data);
              success(response.data);
              return
            }
            response.body = JSON.parse(response.body);
            success(response.body)
          })
        } else {
          success(JSON.parse(response.body));
        }
      } catch (error) {
        console.error('请求响应格式错误：' + error + response)
      }
    }
  }, function (response) {
    if (response.data && typeof response.data == "string" && isPrd) {
      decrypter(response.data).then(function (decryptData) {
        if (decryptData.result) {
          response.data = JSON.parse(decryptData.data);
          ajaxFail(vm, response, error);
          return
        }
        response.data = JSON.parse(response.data);
        ajaxFail(vm, response, error);
      })
    } else {
      ajaxFail(vm, response, error);
    }
  });
};
ajax.toPost = function (obj) {
  /*vm,url,params,headers,success,error*/
  util.showLoading();
  var vuegetsend = obj.headers ? { headers: obj.headers } : {};

  var newUrl = base + obj.url

  if (util.isAddGw()) {
    newUrl = base + '/gw' + obj.url
  }

  Vue.http.post(newUrl, obj.params, vuegetsend).then(function (response) {
    // 关闭loading
    util.closeLoading();
    //响应正确响应
    if (typeof obj.success == 'function' && obj.success != null) {
      // if(response.data){
      //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
      // }
      // obj.success(response);
      if (response.data && typeof response.data == "string" && isPrd) {
        decrypter(response.data).then(function (decryptData) {
          if (decryptData.result) {
            response.data = JSON.parse(decryptData.data);
            obj.success(response)
            return
          }
          response.data = JSON.parse(response.data);
          obj.success(response)
        })
      } else {
        obj.success(response);
      }
    }
  }, function (response) {
    // if(response.data){
    //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
    // }
    // ajaxFail(obj.vm,response,obj.error);
    if (response.data && typeof response.data == "string" && isPrd) {
      decrypter(response.data).then(function (decryptData) {
        if (decryptData.result) {
          response.data = JSON.parse(decryptData.data);
          ajaxFail(obj.vm, response, obj.error)
          return
        }
        response.data = JSON.parse(response.data);
        ajaxFail(obj.vm, response, obj.error)
      })
    } else {
      ajaxFail(obj.vm, response, obj.error);
    }
  });
};

ajax.newPost = function (obj) {
  /*vm,url,params,headers,success,error*/
  util.showLoading();
  var vuegetsend = obj.headers ? { headers: obj.headers } : {};
  var newUrl = base + obj.url
  if (util.isAddGw()) {
    newUrl = base + '/gw' + obj.url
  }

  Vue.http.post(newUrl, obj.params, vuegetsend).then(function (response) {
    // 关闭loading
    util.closeLoading();
    //响应正确响应
    if (typeof obj.success == 'function' && obj.success != null) {
      if (response.data && typeof response.data == "string" && isPrd) {
        decrypter(response.data).then(function (decryptData) {
          if (decryptData.result) {
            response.data = JSON.parse(decryptData.data);
            obj.success(response)
            return
          }
          response.data = JSON.parse(response.data);
          obj.success(response)
        })
      } else {
        obj.success(response);
      }
    }
  }, function (response) {
    if (response.data && typeof response.data == "string" && isPrd) {
      decrypter(response.data).then(function (decryptData) {
        if (decryptData.result) {
          response.data = JSON.parse(decryptData.data);
          obj.error(response)
          return
        }
        response.data = JSON.parse(response.data);
        obj.error(response)
      })
    } else {
      obj.error(response)
    }
  });
};

ajax.postPromise = function (url, params) {
  util.showLoading();
  return new Promise(function (resolve, reject) {
    let newUrl = base + url
    if (util.isAddGw()) {
      newUrl = base + '/gw' + url
    }

    Vue.http.post(newUrl, params).then(function (response) {
      // 关闭loading
      util.closeLoading();
      //响应正确响应
      if (typeof obj.success == 'function' && obj.success != null) {
        if (response.data && typeof response.data == "string" && isPrd) {
          decrypter(response.data).then(function (decryptData) {
            if (decryptData.result) {
              response.data = JSON.parse(decryptData.data);
              resolve(response)
              return
            }
            response.data = JSON.parse(response.data);
            resolve(response)
          })
        } else {
          resolve(response);
        }
      }
    }, function (response) {
      if (response.data && typeof response.data == "string" && isPrd) {
        decrypter(response.data).then(function (decryptData) {
          if (decryptData.result) {
            response.data = JSON.parse(decryptData.data);
            reject(response)
            return
          }
          response.data = reject(response.data);
          reject(response)
        })
      } else {
        reject(response)
      }
    });
  })
};

Vue.http.interceptors.push((request, next) => {
  const newApi = util.isAddGw() ? request.url.split('/')[2] : request.url.split('/')[1]
  // 如果存在access_token，则使用access_token来存放登录态
  const accessToken = getAccessToken()
  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${accessToken}`
  }
  if (
    request.method == 'post' &&
    // request.body && 
    request.url.indexOf('/xwd-api/') === -1 &&
    request.url.indexOf('/auth/') === -1 &&
    request.url.indexOf('/gondarfront-in/') === -1 &&
    request.url.indexOf('/weixinh5/') === -1 &&
    // Object.keys(request.body).length > 0 && 
    isPrd
  ) {
    encrypter({
      kid: newApi || '',
      plaintext: JSON.stringify(request.body)
    }).then(function (encryptData) {
      if (encryptData.result) {
        request.body = encryptData.data
        request.headers['jose'] = 'Y'
        request.headers['Content-Type'] = 'application/json'
      }
      next((response) => {
        //   if (response.data && typeof response.data == "string") {
        //     decrypter(response.data).then(function(decryptData){
        //       if(decryptData.result){
        //         response.body = decryptData.data;
        //         return response
        //       }
        //       return response
        //     })
        //   }else{
        //     return response;
        //   }
        return response;
      });
    })
  } else {
    next((response) => {
      return response;
    });
  }
})



// WEBPACK FOOTER //
// ./web/js/common/ajax/ajax.js